import { useEffect, useState } from 'react';
import { Alert, Button, Input, Modal, Space, Typography, message } from 'antd';
import { previewPaperMetadata } from '../services/api';
import { WarningOutlined } from '@ant-design/icons';

export default function PaperMetadataModal({ paper, onCancel, onConfirm }) {
  const [doi, setDoi] = useState('');
  const [pmid, setPmid] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setDoi(paper?.metadata?.doi || '');
    setPmid(paper?.metadata?.pmid || '');
    setResult(paper?.metadataPreview || null);
  }, [paper]);
  async function lookup(usePdf = false) {
    setLoading(true); setResult(null);
    try {
      setResult(await previewPaperMetadata({ file: paper?.pdfFile,
        doi: usePdf ? '' : doi, pmid: usePdf ? '' : pmid }));
    } catch (error) { message.error(error.message); }
    finally { setLoading(false); }
  }
  const metadata = result?.metadata;
  return (
    <Modal title={<Space><WarningOutlined style={{ color: '#d48806' }} /><span>Identify / confirm metadata</span></Space>} open={!!paper} onCancel={onCancel}
      okText="Confirm metadata" okButtonProps={{ disabled: loading || !result?.token }}
      onOk={() => onConfirm(result)}>
      <Space orientation="vertical" style={{ width: '100%' }}>
        <Typography.Text>Identify the article using its PDF, DOI or PMID, then confirm the result.</Typography.Text>
        <Input placeholder="DOI or https://doi.org/…" value={doi} onChange={(event) => { setDoi(event.target.value); setResult(null); }} />
        <Input placeholder="PMID" value={pmid} onChange={(event) => { setPmid(event.target.value); setResult(null); }} />
        <Space>
          <Button loading={loading} disabled={!doi && !pmid} onClick={() => lookup()}>Look up DOI / PMID</Button>
          <Button loading={loading} disabled={!paper?.pdfFile || !/\.pdf$/i.test(paper.pdfFile.name)} onClick={() => lookup(true)}>Identify from PDF</Button>
        </Space>
        {metadata?.status === 'resolved' && <>
          <Typography.Text strong>{metadata.title}</Typography.Text>
          <Typography.Text type="secondary">{metadata.source === 'pubmed' ? 'PubMed' : 'Crossref'} · {metadata.year}</Typography.Text>
          <Typography.Paragraph copyable>{metadata.citation}</Typography.Paragraph>
        </>}
        {metadata && metadata.status !== 'resolved' && <Alert type="warning" showIcon message="No unambiguous article was found. Enter its DOI or PMID and try again." />}
      </Space>
    </Modal>
  );
}
